import { Table } from 'semantic-ui-react';
import React from 'react';

export default
    {
        demo: {
            todayIs: 'Today is'
        },
        errors: {
            showAllErrors: "Show All Errors ({count})",
            hideErrors: "Hide Errors",
        },
        common: {
            clear: 'Clear',
            bhs: 'B/H/S language',
            eng: 'English language',
            group: 'Group',
            totalEcts: 'Total ECTS:',
            socialStatus: 'Social status',
            academicStaff: 'Academic staff',
            notFound: 'Page not found',
            courseRoleType: 'Role',
            courseDetails: 'Course details',
            details: 'Details',
            ordinal: 'Ord.',
            comment_: 'Note',
            logout: 'Logout',
            editAdd: 'Add / edit',
            add: 'Add',
            send: 'Send',
            cancel: 'Cancel',
            cancelO: 'Cancel',
            ok: 'Confirm',
            firstName: 'Firstname',
            lastName: 'Lastname',
            lastNameAndFirstName: 'Lastname and firstname',
            studentLastNameAndFirstName: 'Student lastname and firstname',
            dateOfAbandonment: 'Date of abandonment',
            maidenName: 'Maiden name',
            student: 'Student',
            index: 'Index',
            degree: 'Degree number',
            edit: 'Edit',
            save: 'Save',
            delete: 'Delete',
            language: 'Language',
            comment: 'Comment',
            titleGender: 'Gender for titles',
            date: 'Date',
            courseName: 'Course name',
            back: 'Back',
            confirm: 'Confirm',
            show: 'Show',
            grade: 'Grade',
            teacher: 'Teacher',
            semester: 'Semester',
            course: 'Course',
            courses: 'Courses',
            faculty: 'Faculty',
            faculties: 'Faculties',
            academicYear: 'Academic year',
            municipality: 'Municipality',
            unsa: 'University of Sarajevo',
            studyCycle: 'Study cycle',
            citizenship: 'Citizenship',
            process: 'Processsing...',
            successfully: 'Successfully...',
            studentsList: 'Students',
            graduatedDate: 'Date of graduation',
            yes: 'YES',
            no: 'NO',
            areYouSure: 'Are you sure?',
            info: 'Informations',
            error: 'Error!',
            oneExamRestrictionError: 'You can register only one exam for this exam term!',
            lecture: 'Lecture (hours)',
            exercise: 'Exercise (hours)',
            lectureExerciseSeminar: 'L + E + S',
            lectureExerciseSeminarAbr: 'L + E + S',
            select: 'Select',
            chose: 'Select',
            average: 'Average',
            gradeAverage: 'Average grade: ',
            studyProgram: 'Study program',
            studyType: 'Study type',
            contact: 'Contact',
            department: 'Department',
            jmbg: 'JMBG',
            username: 'Username',
            accountMail: 'Account e-mail',
            dateOfBirth: 'Date of birth',
            gender: 'Gender',
            father: "Father's firstname and lastname",
            mother: "Mother's firstname and lastname",
            fatherName: "Father's firstname",
            motherName: "Mother's lastname",
            placeOfBirth: 'Place of birth',
            residence: 'Residence',
            currentResidence: 'Current residence',
            nationality: 'Nationality',
            classroom: 'Classroom',
            noResultMessage: 'No results found!',
            description: 'Description / note',
            phone: 'Phone',
            mail: 'E-mail',
            studyAddress: 'Current adress',
            cantonResidence: 'Canton of residence',
            municipalityResidence: 'Municipality of residence',
            addressResidence: 'Address of residence',
            archive: 'Archive',
            courseCode: 'Course code',
            code: 'code',
            startPage: ' ',
            editOrAdd: 'Add / edit',
            coursesList: 'Courses',
            leadStaff: 'Lead staff',
            filterRequired: 'You must enter what you want to filter!',
            studyProgramName: 'Study program name',
            selectStudyProgram: 'Select study program',
            inputIndex: 'Enter index number',
            inputName: 'Enter firstname',
            inputLastName: 'Enter lastname',
            personalInfo: 'Personal info',
            students: 'Students',
            courseType: 'Course type',
            mandatory: 'Mandatory',
            optional: 'Optional',
            notice: 'Notice',
            notification: 'Notification',
            notifications: 'Notifications',
            inputNotification: 'Enter notification text..',
            newNotifications: 'New notifications',
            newNotification: 'New notification',
            markAllAsRead: 'Mark all as read',
            new: 'NEW',
            activeNotifications: 'Active notifications',
            previousNotifications: 'Previouse notifications',
            noNewNotifications: 'You don\'t have new notifications.',
            noActiveNotifications: 'You don\'t have active notifications.',
            noPreviousNotifications: 'You don\'t have previous notifications.',
            title: 'Notification title',
            notificationType: 'Notification type',
            notificationStartDate: 'Publication date',
            notificationEndDate: 'Expiration date',
            recipientsProfessors: 'Recipients (Professors)',
            recipientsEmployees: 'Recipients (Employee)',
            recipientsStudents: 'Recipients (Students)',
            requiredFields: 'You must fill all required fields.',
            requiredEmailForm: 'Enter valid email.',
            notificationSent: 'Notification was successfully sent.',
            notificationSentError: 'Failed to add new notification.',
            employees: 'Employees',
            professors: 'Professors',
            image: 'Student image',
            semesterName: 'Semester name',
            semesterNumber: 'Semester number',
            applicationDate: 'Application date',
            english: 'English',
            bosnian: 'B / C / S',
            startEngagement: 'Start of employment',
            endEngagement: 'End of employment',
            titleElection: 'Election to the title',
            academicTitle: 'Title',
            titleExpiration: 'Expiration of the title',
            noEmploymentInfo: 'No information about the title of employee. Contact your HR administrator.',
            noPositionInfo: 'No information about the positions of employee. Contact your HR administrator.',
            filterStudents: 'Search',
            noData: 'No data...',
            noDataToDisplay: 'No data to display.',
        },
        poll: {
            index: 'No.',
            polls: 'Polls',
            access: 'Access',
            accessProhibited: 'prohibited',
            accessGranted: 'granted',
            ban: 'Ban',
            approve: 'Approve',
            results: 'Results',
            pollResults: 'Results',
            reviewResults: 'Review results',
            question: 'Pitanje',
            questions: 'Pitanja',
            active: 'Aktivne ankete',
            created: 'Kreirane ankete',
            archived: 'Arhivirane ankete',
            pollTitle: 'Poll title',
            title: 'Title',
            type: 'Type',
            startDateStudents: 'Start date for students',
            startDate: 'Start date',
            endDate: 'End date',
            pollDetails: 'Details',
            details: 'Details',
            edit: 'Edit',
            delete: 'Delete',
            overview: 'Poll list',
            createNewPoll: 'Create new poll',
            newPoll: 'Nova anketa',
            creatingPoll: 'Kreiranje ankete',
            pollType: 'Poll type',
            comment: 'Comment',
            placeholderPollName: 'Unesite naziv',
            placeholderType: 'Odaberite tip',
            placeholderDate: 'Unesite datum',
            placeholderComment: 'Unesite komentar..',
            placeholderAnswer: 'Unesite odgovor',
            placeholderQuestion: 'Unesite pitanje',
            placeholderOfferedAnswer: 'Unesite ponuđeni odgovor',
            createPollButton: 'Kreiraj anketu',
            cancel: 'Odustani',
            addQuestionButton: 'Dodaj pitanje',
            addAnswerButton: 'Dodaj odgovor',
            offeredAnswers: 'Ponuđeni odgovori',
            section: 'Section',
            placeholderAssistants: 'Odaberite asistente',
            placeholderProfessors: 'Odaberite profesore',
            numberOfStudentsOnCourse: 'Number of students on course',
            numberOfStudentsWhoDoneCourse: 'Number of students who graded the course',
            numberOfStudentsWhoDoneProfessor: 'Number of students who evaluated the professor',
            numberOfStudentsWhoDoneAssistant: 'Number of students who evaluated the assistant',
            coursesOnPoll: 'Courses',
            noCoursesMess: 'Your courses are not on this poll.',
            noPollMess: 'There are currently no polls created.',
            noStudentsMess: 'No students in the selected course.',
            lateImplementationMess: 'The implementation of the course was created after the start of the poll.',
            noCoursesAssigned: 'You are not assigned to courses this semester.',
            sp: 'Study program',
            noDataForExcelExport: "There was an error. No data available for generating the Excel file.",
            errorWhileExcelExport: "There was an error while generating the Excel file.",
            successfullExcelExport: "Excel file successfully generated."
        },
        sidebar: {
            home: 'Home',
            personalInfo: 'Personal info',
            study: 'Study',
            gradesOverview: 'Grades',
            coursesOverview: 'Study program overview',
            collision: 'Collision courses',
            optional: 'Optional courses',
            currentSemesterCourses: 'Current semester',
            exams: 'Exams',
            activeExams: 'Active exams',
            finalizedExams: 'Finalized exams',
            register: 'Exam register',
            registeredExams: 'Registered exams',
            documents: 'Documents',
            comment: 'Comments and suggestions',
            contact: 'Contact information',
            courses: 'Courses',
            statistic: 'Statistic',
        },

        route: {
            home: 'Home',
            personalInfo: '/student-personal-information',
            collisionCourses: '/collision-courses',
            optionalCourses: '/optional-courses',
            currentSemesterCourses: '/current-semester-courses',
            gradesOverview: '/grades',
            coursesOverview: '/study-program-overview',
            passedExams: '/passed-exams',
            registerExams: '/register-exams',
            registeredExams: '/registerd-exams',
            requests: '/documents',
            comments: '/comments-and-suggestions',
            contact: '/contact-information',

            finalized: '/finalized-exams',
            studentGrades: '/finalized-exams/students-list',
            examStatistic: '/finalized-exams/statistic',
            active: '/active-exams',
            inputGrades: '/active-exams/input-grades',
            filterStudentsForProfessor: '/students',
            studentsInfoFromSearch: '/students/profile',
            studentGradesAndInfo: '/active-exams/input-grades/student-info',
            studentGradesAndInfoFromFinalised: '/finalised-exams/students/student-info',
            upcomingExams: '/upcoming-exams',
            statistic: '/statistic-for-professor',
            personalInf: '/personal-information',
            courses: '/courses-list',
            studentsInfo: '/courses-list/students/information',
            studentsInfoSS: '/nastavno-osoblje/predmeti/studenti/detalji',
            students: '/courses-list/students',
            courseStudents: '/courses-list/students',
            courseDetails: '/courses-list/details',
            courseStatistic: '/courses-list/statistic',
            registeredStudents: '/registered-students',
            academicStaff: '/academic-staff',

            polls: '/polls',
            pollCourses: '/polls/courses',
            pollResults: '/polls/courses/results',
            access: '/poll-access',
            accessCourses: '/poll-access/courses',
            accessStudents: '/poll-access/courses/students',
            faq: '/faq',


        },
        orgUnitDetailed: {
            orgUnits: 'Organizacione jedinice',
            parents: 'Roditelji',
            types: 'Tipovi',
            addOrgUnitType: 'Dodaj tip',
            staffPosition: 'Position',
            staff: 'Staff',
            addresses: 'Adrese',
            addressesDesc: 'Sve adrese ove organizacione jedinice',
            street: 'Ulica',
            place: 'Mjesto',
            contacts: 'Contacts',
            addContacts: 'Dodaj kontakt',
            contactValue: 'Value',
            contactDescription: 'Description',
            contactType: 'Type',
            name: 'Name',
            errors: {
                changeName: 'Greska pri promjeni imena organizacione jedinice',
                gettingHierarchy: 'Greska pri dobavljanju hijerarhije',
                gettingOrgUnitDetails: 'Greska pri dobavljanju organizacione jedinice',
                gettingContactType: 'Greska pri dobavljanju tipova kontakta',
                addingContact: 'Greska pri dodavanju kontakta',
                deletingContact: 'Greska pri brisanju kontakta',
                creatingOrgUnit: 'Greska pri kreiranju organizacione jedinice',
                gettingOrganizationalUnits: 'Greska pri dobavljanju organizacionih jedinica',
                addingParent: 'Greska pri dodavanju roditelja',
                gettingPositions: 'Greska pri dobavljanju pozicija',
                gettingEmployees: 'Greska pri dobavljanju zaposlenika',
                mustHaveType: 'Ne moze se dodati zaposlenik ako nema tip organizacione jedinice',
                addingStaff: 'Greska pri dodavanju staff',
                gettingOrgUnitTypes: 'Greska pri dobavljanju tipova',
                addingOrgUnitTypes: 'Greska pri dodavanju tipova'
            }
        },

        student: {
            exams: 'Exams',
            canceled: 'You successfully canceled exam application.',
            registered: 'You successfully registered exam.',
            summerSemester: 'Summer semester',
            winterSemester: 'Winter semester',
            studyProgramView: 'Study program overview',
            collision: 'Collision',
            availableCollision: 'Available collision courses',
            theRestEcts: 'The rest of ECTS: ',
            currentSemesterCourses: 'Current semester courses',
            currentCourses: 'Current optional courses',
            noCollisionMessage: 'No current collision courses for register.',
            noCoursesMessage: 'No current optional courses.',
            noCurrentSemesterMessage: 'You are not enrolled in the current semester, and for that reason you cannot see the courses. Contact the student service of the faculty/academy.',
            optionalCourses: 'Optional courses',
            selectOptionalCourse: 'Confirm choice',
            availableOptionalCourses: 'Available optional courses',
            noElectiveMessage: 'No current optional courses for register.',
            study: 'Grades',
            showGrades: 'Grades overview',
            noGradesMessage: 'No grades!',
            deleteContactToast: 'The contact has been successfully deleted!',
            editContactToast: 'The contact has been successfully edited',
            editContactErrToast: 'Error! The contact has not been deleted!',
            addContactToast: 'The contact has been successfully added.',
            basicInfo: 'Basic info',
            previousEducation: 'Previous education',
            currentStudy: 'Current study',
            examDate: 'Exam date',
            registeredExams: 'Registerd exams',
            currentRegisteredExams: 'Current registered exams',
            noRegisteredExamsMessage: 'No registered exams.',
            allRegisteredExams: 'All registered exams',
            noPreviousRegisteredExamsMessage: 'No previous registered exams.',
            cancelExam: 'Cancel exam',
            registerExam: 'Exam register',
            register: 'Register exam',
            noExamsForRegisterMessage: 'No exams for register.',
            addNewContact: 'Add new contact',
            noContactInfo: 'No contact information.',
            passedExamsNumber: 'Number of passed exams',
            noCurrentSemesterCourses: 'No current semester courses.',
            registeredStudentsList: 'Registered students',
            accountInfo: 'Account info',
            userRole: 'User roles'
        },
        studentDocuments: {
            documentType: 'Document type',
            status: 'Status',
            add: 'Add request',
            editRequest: 'Edit current request',
            docRequest: 'Current document requests',
            createRequest: 'Add new document request',
            requests: 'Documents',
            send: 'Send',
            certificateType: 'Document type',
            selectCertificateType: 'Select document type',
            certificateReason: 'Certificate reason',
            selectCertificateReason: 'Select certificate reason',
            selectLanguage: 'Select language',
            writeComment: 'Comment...',
            previousDocRequest: 'Previous document requests',
            CurrentRequestMessage: 'No current document requests.',
            PreviousRequestMessage: 'No previous document requests.',
            sentRequestToast: 'Request was successfully sent',
            errSentRequestToast: 'Error! Request is not sent.',
            cancelRequestToast: 'Request canceled.',
            cancelPopup: 'This request will be canceled!',
            showPopup: 'Show previous requests.',
            errInputToast: 'You did not enter all fields!'
        },
        professorInputGrades: {
            importInfo1: "The selected file must contain the following four columns:",
            importInfo2: "Grades must be from the allowed set.",
            importInfo3: "If there are duplicate students (same index) in the excel file, the grade from the later row will be used.",
            orderNotImportant: "The order of the columns is not important.",
            missingRequiredFields: "Row {row}: One of the required fields is missing (index, first name, last name, grade).",
            studentNotFound: "Row {row}: Student \"{firstName} {lastName}\" with index \"{index}\" was not found among ungraded students.",
            invalidGrade: "Row {row}: Grade \"{grade}\" is not valid.",
            importGrades: "Import grades",
            uploadFile: "Upload Excel file",
            invalidFormat: "Invalid file format. Only .xlsx is allowed.",
            invalidGrade: "Invalid grade for student {index} ({ime}) – grade must be one of the allowed values.",
            importSuccess: "Grades successfully loaded.",
            noFileSelected: "No file selected.",
            invalidFileStructure: "File structure is incorrect. Required columns: index, full name, grade.",
            submitImportedGrades: "Submit grades",
            importedGradesInfo: "Imported grades will be shown in the table. After reviewing, click the button to submit grades.",
            clearImportedGrades: "Clear imported grades",
            invalidRowsFound: "Invalid grades found. Please review and try again.",
            noGrade: "No grade",
            selectFile: "Select file",
            uploadExcel: "Upload Excel file with grades",
            importSubmit: "Submit grades",
            importSuccess: "Grades successfully imported",
            importFailed: "Error importing grades",
            importErrors: "Error importing grades",
            grade2: "Grade",
            toastGradeImportSuccess: "Grades successfully imported.",
            toastGradeImportFailed: "Error importing grades.",

            finalizeInfo: 'After exam finalization all students that remained in not graded list will get grade',
            finalizeInfo2: 'not graded / did not attend exam.',
            grade: 'Grade',
            groupGrading: 'Group grading',
            groupGradingInfo: 'For group grading check students from the list (you can click on a table row or checkbox in the first row) ' +
                'and then choose grade. When you click on the button ',
            groupGradingInfo2: 'Grade',
            groupGradingInfo3: ' all of the checked students will be graded with chosen grade.',
            individuallyGrading: 'Individually grading',
            infoView: 'Overview',
            info: 'Information',
            personalInfo: 'Personal info',
            semesters: 'Semester overview',
            currentSemester: 'Current semester',
            studyInfo: 'Current study information',
            finalizeCheck: 'Are you sure you want to finalize the exam?',
            endOfEmploymentDate: 'Date of end of employment',
            endOfEmployment: 'End of employment',
            endOfEmploymentButton: 'End employment',
            contact: 'Contact information',
            inputGrades: 'Input grades',
            selectCourse: 'Select course',
            selectExamTerms: 'Select exam term',
            examType: 'Exam type',
            attention: 'Attention',
            registration: 'Registration',
            passed: 'Passage',
            selectGrade: 'Grade',
            course: 'Course',
            confirm: 'Confirm',
            studentsWithoutGrades: 'Not graded students',
            studentsWithGrades: 'Graded students',
            studyYear: 'Study year',
            department: 'Department',
            studyProgram: 'Study program',
            studentStudyType: 'Study type',
            selectStudyType: 'Select student status',
            selectStudyProgram: 'Select study program',
            selectDate: 'Select exam date',
            graded: 'Graded',
            edit: 'Edit',
            confirmGrade: 'Confirm grade',
            cancelGrade: 'Cancel grade',
            filterData: 'Filter data.',
            showTable: 'Show graded students.',
            CurrentGradesMessage: 'No graded students.',
            CurrentGradesFilterMessage: 'Filters on! No students are graded.',
            PreviousGradesMessage: 'There are no students who are not graded',
            PreviousGradesFilterMessage: 'Filters on! No students are graded',
            PreviousNoGradesFilterMessage: 'Filters on! There are no students who are not graded',
            selectAcademicYear: 'Select academic year',
            selectSemester: 'select semester',
            examDate: 'Exam term',
            examDateDate: 'Exam date and time',
            examFinalizationTime: 'Exam finalization date and time',
            examOnlyDate: 'Exam date',
            selectExamDate: 'Select exam term',
            showStudents: 'Show students',
            selectNewCourse: 'Selec',
            inputFirstName: 'Enter firstname',
            inputLastName: 'Enter lastname',
            FiltersOn: 'Filters on!',
            getFilter: 'Filter',
            finalize: 'FINALIZE    EXAM',
            toastFilter: 'Choose what you want to filter data for!',
            toastFilterFailed: 'Filter failed',
            toastFilanizedExam: 'The exam is finalized!',
            toastStudentGraded: 'The student has been successfully graded!',
            toastStudentsGraded: 'The students have been successfully graded!',
            toastStudentGradedFailed: 'Error! Student not graded.',
            toastStudentsGradedFailed: 'Error! Students not graded.',
            activeExamsList: 'Active (non-finalized) exams',
            NoDataMessage: 'No active exams.',
            numberOfStudents: 'Number of registered students',
            gradeStudents: 'Gradeing students',
            registeredStudents: 'Students',
            activeCourse: 'Active exams',
            finalizedCourse: 'Finalized exams',
            finalizedCourseList: 'Finalized exams',
            toastStudentGradeEdited: 'The grade has been successfully updated.',
            toastStudentGradeCancel: 'The grade has been successfully canceled.',
            toastStudentGradeEditFailed: 'Error! The grade has not been edited.',
            toastStudentGradeCancelFailed: 'Error! The grade has not been canceled.',
            startDate: 'Exams of:',
            endDate: 'Exams up to:',
            NofinalizedExamsMessage: 'No finalized exams.',
            endAndStartDate: 'You need to enter from which date you want to take exams!',
            toastFinalizedFailed: 'The exam is not finalized!',
            NoUpcomingExamsMessage: 'No upcoming exams.',
            upcomingExams: 'Upcoming exams',
            upcomingExamsList: 'Upcoming exams',
            toastFinalized: 'The exam was successfully finalized!',
            studentInfo: 'Student information',
            showStudentInfo: 'Show student information',
            gradesList: 'Grades',
            inputGradeDate: 'Exam entry date',
            positions: 'Positions',
            titles: 'Titles',
            inputCourseName: 'Enter course name',
            gradedStudentsNumber: 'Number of graded students',
            averageGrade: 'Average grade: ',
            noDataForAcademicYear: 'No data for the selected academic year.',
            noCourses: 'No courses.',
            noCoursesMessage: 'No courses for selected academic year.',
            noCoursesMessageSS: 'No courses.',
            noCoursesFilter: 'Filters on! No courses.',
            gradedStudents: 'Graded students',
            notGradedStudents: 'Not graded students',
            printGradesList: ' Graded students by index number',
            printStudentsList: ' Registered students',
            finalizationCancelDate: 'Finalization cancle date',

        },
        professorStatistics: {
            statistics: 'Statistic',
            numberOfStudents: 'Number of students per subject',
            averrageGrade: 'Average grade',
            NoDataMessage: 'No data for this academic year.',
            currentAcademicYear: 'Current academic year',
            studentsChart: 'Number of students per course',
            gradeChart: 'Average grade per course',
            graphicShow: 'Graphic',
            tableShow: 'Table',
            courseId: 'Ordinal number',
            selectAcademicYear: 'Select academic year',
            academicYearHeader: ' academic year',
            courseStatistic: 'Statistics of the course',
            statisticForCourse: 'Statistics of the course: ',
            noStudents: 'No students.',
            noCourses: 'No course info.',
            noStudentsFilter: 'Filters on! No students.',
            printRegisteredStudents: 'Print a list of registered students',
            printStudentGrades: 'Print a list of students with grades',
            notFinalRegisteredStudentsList: '*The list of registered students is not final, because the exam is still open for application. ',
            noRegisteredStudents: 'No students registered.',
            studyProgramCourse: 'at which course is taught',
            courseExamDate: 'Course name / exam type / exam date',
            numberOfStudentsOnCourse: 'Number of students on course',
            numberOfDistinctStudentGradedActivities: 'Number of distinct students graded activities',
            numberOfExamRegistrations: 'Number of exam registrations',
            numberOfDistinctStudentsWhoAccessedExam: 'Number of distinct students who accessed exam.',
            numberOfStudentsWhoAccessedExam: 'Number of students who accessed exam',
            numberOfStudentsWhoPassed: 'Number of students who passed course',
            averagePassed: 'Average passed',
            five: '5 (five)',
            six: '6 (six)',
            seven: '7 (seven)',
            eight: '8 (eight)',
            nine: '9 (nine)',
            ten: '10 (ten)',
            nonp: 'not graded/did not attend exam',
            io: 'fulfilled obligations',
            nz: 'nije zadovoljio',
            z: 'passed',
            no: 'nije odbranio',
            uo: 'successfully defended',
            np: 'not passed',
            na: 'did not defend',
            courseName: 'Course name',

        },
        contact: {
            contact: 'Contact information',
            unsa: 'UNSA',

            selectCommentType: 'Select comment type',
            inputMail: 'Input e-mail address',
            inputTitle: 'Input title',
            text: 'Text...',
            text_: 'Text',
            title: 'Message title',
            email: 'Your e-mail address',
            comments: 'Comments and suggestions',
            form: 'Form',
            errorMess: 'Niste unijeli sva obavezna polja.',
            mailValidationError: 'Enter valid email.',
            success: 'Vaš komentar / prijedlog je uspješno poslan.',
            error: 'Došlo je od greške! Vaš komentar / prijedlog nije poslan.',
        },

        statistics: {
            statistic: 'Statistic',
            selectFacultyAndAcademicYear: 'Odaberite fakultet i akademsku godinu',
            selectFacultyAcademicYearAndStudyCycle: 'Odaberite fakultet, akademsku godinu i studijski ciklus',
            selectFaculty: 'Odaberite fakultet',
            selectAcademicYear: 'Odaberite akademsku godinu',
            selectStudyCycle: 'Odaberite studijski ciklus',
            citizenship: 'Državljani',
            selectCitizenship: 'Odaberite državljanstvo studenata',
            headerNumberEnrolledStudents: 'Broj upisanih studenata u prvi semestar ',
            headerAcademicYear: ' akademske godine',
            tableShow: 'Tabelarni prikaz',
            graphicShow: 'Grafički prikaz',
            place: 'Mjesto',
            numberOfStudents: 'Broj studenata',
            headerNumberEnrolledStudentsPerStudyCycles: 'Broj upisanih studenata u prvi semestar po studijskom ciklusu ',
            studentsNumber: 'Ukupan broj studenata: ',
            headerNumberEnrolledStudentsPerStudyTypes: 'Broj upisanih studenata u prvi semestar prema statusu studiranja ',
            headerNumberEnrolledStudentsPerAcademicYearsAndCycles: 'Broj upisanih studenata po studijskim godinama i ciklusima ',
            studyYear: 'Godina studija',
            headerNumberGraduatedStudentsPerStudyCycles: 'Broj studenata koji su završili određeni studijski ciklus ',
            headerNumberGraduatedStudents: 'Broj studenata koji su završili',
            graduated: 'diplomanata',
            enrollledBiH: 'Upisanih BH državljana',
            enrolledOther: 'Upisanih stranih državljana',
            graduatedStudents: 'Diplomirani studenti',
            perCyclesForFaculty: 'Po ciklusima za fakultet',
            perCyclesForFacultyMF: 'Po ciklusima za fakultet (M/Ž)',
            perCyclesForUniversity: 'Po ciklusima za Univerzitet',
            enrolledPerFaculty: 'Upisani studenti po fakultetima',
            perCycles: 'Po ciklusima',
            perStudyType: 'Prema statusu studiranja',
            perCountries: 'Po državama',
            perStudyYearAndCycles: 'Po studijskim godinama i ciklusima',
            perMunicipality: 'Po BH općinama',
            enrolledForUniversity: 'Upisani studenti na Univerzitetu',


        },
    };



// WEBPACK FOOTER //
// ./src/messages/messages_en.js